import interceptorAxios from './InterceptorAxios';
const ServicioTcExpediente ={
    
    paginacion(objeto){
        return interceptorAxios.post('/expediente/paginacion.json',objeto);
    },
    eliminarExpedienteAdmin(objeto){
        return interceptorAxios.post('/expediente/eliminar_expediente_admin.json',objeto);
    },
    paginacionExAdmin(objeto){
        return interceptorAxios.post('/expediente/paginacion_expediente_admin.json',objeto);
    },
   
    procesarExpTra(objeto,estado,nombre,identificador){
        return interceptorAxios.post("/expediente/procesar_expediente_trabajador.json?visible="+estado+"&&tipo="+nombre+"&&id="+identificador, objeto); 
     }
    

}
export default ServicioTcExpediente;